import enTranslations from "./en";
import plTranslations from "./pl";

export default {
  pl: plTranslations,
  en: enTranslations,
};
